import React, { useLayoutEffect } from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';

am4core.useTheme(am4themes_animated);

const processData = (data) => {
  return data.map(item => ({
    ...item,
    year: item.year.toString().replace('.0', '')
  }));
};

const AgeBarChart = ({ data }) => {
  const processedData = processData(data);

  useLayoutEffect(() => {
    let chart = am4core.create('agebarchart', am4charts.XYChart3D);
    chart.paddingBottom = 30;
    chart.angle = 35;

    chart.logo.disabled = true;

    chart.data = processedData;

    let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = 'year';
    categoryAxis.renderer.grid.template.disabled = true; 
    categoryAxis.renderer.labels.template.disabled = false; 
    categoryAxis.renderer.minGridDistance = 30;
    categoryAxis.numberFormatter.numberFormat = '#';

    categoryAxis.renderer.labels.template.text = '{categoryX}'; // Removes dots

    let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.min = 0;
    valueAxis.max = 100;
    valueAxis.renderer.grid.template.disabled = true; 
    valueAxis.renderer.labels.template.disabled = true; 

    const createSeries = (field, name, color) => {
      let series = chart.series.push(new am4charts.ColumnSeries3D());
      series.dataFields.valueY = field;
      series.dataFields.categoryX = 'year';
      series.name = name;
      series.stacked = true;
      series.columns.template.tooltipText = '[bold]{name}[/]\n[font-size:14px]{categoryX}: {valueY}%';
      series.columns.template.fill = color;
      series.columns.template.stroke = color;
     
      let valueLabel = series.bullets.push(new am4charts.LabelBullet());
      valueLabel.label.text = '{valueY}%';  
      valueLabel.label.fill = am4core.color('#FFFFFF'); 
      valueLabel.label.fontSize = 12; 
      valueLabel.locationY = 0.5; 
    };

    createSeries('16-24', '16-24', am4core.color('#FF6347'));
    createSeries('25-34', '25-34', am4core.color('#4682B4'));
    createSeries('35-44', '35-44', am4core.color('#32CD32'));
    createSeries('45-54', '45-54', am4core.color('#FFD700'));
    createSeries('55-69', '55-69', am4core.color('#FF69B4'));
    createSeries('70plus', '70+', am4core.color('#8A2BE2'));

    chart.legend = new am4charts.Legend();

    return () => {
      chart.dispose();
    };
  }, [processedData]);

  return <div id="agebarchart" style={{ width: "100%", height: "500px" }}></div>;
};

export default AgeBarChart;